export class FotoBlob {
  blob: any;
  oFoto: any;
  name: string;
  size: number;
  constructor(){}
}



// WEBPACK FOOTER //
// C:/Users/adri9/Escritorio/admin-everpath/src/app/domain/FotoBlob.ts